import { font, colors, spacing, ChevronIcon, breakpoints } from '@chegg-ui/theme';
import { Accordion } from '@chegg-ui/accordion';
import { IconButton } from '@chegg-ui/button';
import { Link } from '@chegg-ui/link';
import styled, { css } from 'styled-components';
import { borderRadius } from './externals';
import { TopLevelNavLink, mobileLinkHeightInPixels, StyledToggletip } from './styles';
var size = font.size,
    weight = font.weight,
    lineHeight = font.lineHeight;
export var LogoLink = styled.a.withConfig({
  componentId: "j4kgig-0"
})(["color:", ";display:flex;margin-left:", ";margin-right:", ";text-decoration:none;&:link,&:visited,&:hover,&:active{text-decoration:none;}& > svg{fill:", ";}@media (max-width:calc(", " + 50px)){margin-right:auto;margin-left:", ";& > svg{height:1.25rem;width:3.75rem;}}"], colors.cheggOrange, spacing.px16, spacing.px16, colors.cheggOrange, breakpoints.md.max, spacing.px8);
var NavAllItemBaseStyle = css(["font-size:", ";line-height:", ";color:", ";text-decoration:none;&:hover{text-decoration:none;}&:visited{color:", ";}"], size.px16, lineHeight.sm, colors.dark, colors.dark);
var NavTopItemBaseStyle = css(["", " font-weight:bold;position:relative;padding:0 ", ";&::before{height:0;bottom:-9px;position:absolute;display:block;width:calc(100% - ", ");content:'';background-color:", ";transition:bottom 0.2s;}&:hover{text-decoration:none;&:before{height:5px;bottom:-4px;}}"], NavAllItemBaseStyle, spacing.px16, spacing.px32, colors.cheggOrange);
export var NavLink = styled(Link).withConfig({
  componentId: "j4kgig-1"
})(["", " &::before{", "}"], NavTopItemBaseStyle, function (props) {
  return props.isActive ? css(["height:5px;bottom:-4px;"]) : css(["height:0;bottom:-9px;"]);
});
export var NavDropdownItem = styled.span.withConfig({
  componentId: "j4kgig-2"
})(["", " cursor:pointer;display:inline-flex;align-items:center;&::before{", "}"], NavTopItemBaseStyle, function (props) {
  return props.isActive ? css(["height:5px;bottom:-4px;"]) : css(["height:0;bottom:-9px;"]);
});
var activeNavLinkCss = "\n  color: ".concat(colors.white, ";\n  background-color: ").concat(colors.dark, ";\n  border-radius: 0.25rem;\n");
export var MenuButton = styled(IconButton).withConfig({
  componentId: "j4kgig-3"
})(["padding:0;&:hover{color:", ";transform:none;}"], colors.cheggOrange);
export var StyledAccordion = styled(Accordion).withConfig({
  componentId: "j4kgig-4"
})(["box-sizing:border-box;padding:0 ", ";& > h2 > button{padding-left:", ";}", ""], spacing.px8, spacing.px8, function (_ref) {
  var activeTabIndex = _ref.activeTabIndex;
  return activeTabIndex >= 0 ? // we need the multiplication logic as there are `<div>` panel siblings between each `<h2>`
  "\n        & > h2:nth-child(".concat(activeTabIndex * 2 + 1, ") > button {\n          ").concat(activeNavLinkCss, "\n        }\n        & > div {\n          border-bottom: 0;\n        }\n      ") : '';
});
export var NavMobileTopLevelMenuItem = styled.span.withConfig({
  componentId: "j4kgig-5"
})(["display:flex;align-items:center;text-decoration:none;height:", "px;font-size:1rem;flex-grow:1;color:inherit;white-space:nowrap;&:hover,&:active{text-decoration:none;}"], mobileLinkHeightInPixels);
export var NavMobileTopLevelLink = styled(TopLevelNavLink).withConfig({
  componentId: "j4kgig-6"
})(["margin:0 ", ";padding:0 ", ";border-bottom:1px solid ", ";", ""], spacing.px8, spacing.px8, colors.greyLight, function (_ref2) {
  var isActive = _ref2.isActive;
  return isActive ? activeNavLinkCss : "&:hover {\n        background-color: ".concat(colors.greyXlight, ";\n      }");
});
export var LinkAccordionPanel = styled.div.withConfig({
  componentId: "j4kgig-7"
})(["background-color:#eeeeee;border-radius:0 0 ", " ", ";max-height:60vh;overflow-y:scroll;"], borderRadius.medium, borderRadius.medium);
export var NavLinkText = styled.p.withConfig({
  componentId: "j4kgig-8"
})(["font-family:", ";font-weight:", ";margin:0;margin-left:", ";"], font.family["default"], font.weight.medium, function (props) {
  return props.extraMargin ? "calc(".concat(spacing.px24, " + ").concat(spacing.px12, ")") : spacing.px12;
});
export var NavDropdownLink = styled(Link).withConfig({
  componentId: "j4kgig-9"
})(["", " min-width:11rem;margin:", " 0;font-weight:", ";&:hover{font-weight:", ";}"], NavAllItemBaseStyle, spacing.px12, weight.normal, weight.bold);
export var DropDownList = styled.ul.withConfig({
  componentId: "j4kgig-10"
})(["display:flex;flex-flow:column wrap;list-style:none;padding:0;margin:0;"]);
export var Divider = styled.div.withConfig({
  componentId: "j4kgig-11"
})(["border-right:1px solid ", ";margin:0 ", ";"], colors.greyLight, spacing.px12);
export var StyledChevronIcon = styled(ChevronIcon).withConfig({
  componentId: "j4kgig-12"
})(["margin-left:", ";"], spacing.px4);
export var UserDropdownInfo = styled.li.withConfig({
  componentId: "j4kgig-13"
})(["background-color:", ";border-radius:", " ", " 0 0;margin:-1px;width:300px;"], colors.dark, borderRadius.medium, borderRadius.medium);
export var BlackStyledToggletip = styled(StyledToggletip).withConfig({
  componentId: "j4kgig-14"
})(["margin-left:", ";& > div:last-child{&:before{border-bottom-color:", ";background-color:", ";}&:after{border-bottom-color:transparent;background-color:", ";}}"], spacing.px12, colors.dark, colors.dark, colors.dark);